/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParticipantLink } from './ParticipantLink';
import {
    ParticipantLinkFromJSON,
    ParticipantLinkFromJSONTyped,
    ParticipantLinkToJSON,
    ParticipantLinkToJSONTyped,
} from './ParticipantLink';

/**
 * 
 * @export
 * @interface ParticipantLinkResponse
 */
export interface ParticipantLinkResponse {
    /**
     * 
     */
    data: ParticipantLink;
}

/**
 * Check if a given object implements the ParticipantLinkResponse interface.
 */
export function instanceOfParticipantLinkResponse(value: object): value is ParticipantLinkResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ParticipantLinkResponseFromJSON(json: any): ParticipantLinkResponse {
    return ParticipantLinkResponseFromJSONTyped(json, false);
}

export function ParticipantLinkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantLinkResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ParticipantLinkFromJSON(json['data']),
    };
}

export function ParticipantLinkResponseToJSON(json: any): ParticipantLinkResponse {
    return ParticipantLinkResponseToJSONTyped(json, false);
}

export function ParticipantLinkResponseToJSONTyped(value?: ParticipantLinkResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ParticipantLinkToJSON(value['data']),
    };
}

